import { clsx } from 'clsx';
import { FormControlLabel, Radio } from '@material-ui/core';

import makeClasses from './RadioOption.style';

import type { RadioOptionProps } from './radioOption.model';

export function RadioOption(props: RadioOptionProps) {
  const {
    variant = 'default',
    fullWidth = true,
    classes = {},
    title,
    description,
    children = null,
    radioProps = {},
    ...restFormControlLabelProps
  } = props;

  const _classes = makeClasses({ variant, fullWidth });

  return (
    <FormControlLabel
      classes={{
        ...classes?.formControlLabel,
        root: clsx(_classes.root, classes?.formControlLabel?.root),
      }}
      label={
        <div className={clsx(_classes.labelRoot, classes?.label?.root)}>
          <h3
            hidden={!title}
            className={clsx(_classes.labelTitle, classes?.label?.title)}
          >
            {title}
          </h3>
          <p
            hidden={!description}
            className={clsx(
              _classes.labelDescription,
              classes?.label?.description,
            )}
          >
            {description}
          </p>
          {children}
        </div>
      }
      control={
        <Radio
          disableRipple
          color='default'
          {...radioProps}
          classes={{
            ...radioProps?.classes,
            root: clsx(_classes.radio, radioProps?.classes?.root),
            checked: clsx(_classes.radioChecked, radioProps?.classes?.checked),
          }}
        />
      }
      {...restFormControlLabelProps}
    />
  );
}
